import React, { Dispatch, FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import Input from 'core/react/general/form/Input';
import removeIcon from 'core/img/icons/trash.png';
import { IAttributeDetectorForm } from 'hooks/attribute-range-detectors/useAttributeDetectorForm';

import {
  FieldErrorStyled,
  StringEnumerationFieldStyled,
} from 'ui/pages/attribute-range-detectors/string-enumeration.styled';

interface IPassProps {
  isDisabled: boolean;
  fieldIndex: number;
  remove: Dispatch<number>;
}

export const StringEnumerationField: FC<IPassProps> = (props) => {
  const { isDisabled, fieldIndex, remove } = props;

  const { control, formState } = useFormContext<IAttributeDetectorForm>();

  const error = formState.errors?.stringEnumeration?.[fieldIndex]?.enumeration?.message;

  const removeEnumeration = () => remove(fieldIndex);

  return (
    <>
      <StringEnumerationFieldStyled isDisabled={isDisabled}>
        <Controller
          control={control}
          name={`stringEnumeration.${fieldIndex}.enumeration`}
          rules={{ required: fc('please enter a value') }}
          render={({ value, onChange }) => <Input disabled={isDisabled} value={value} onChange={onChange} />}
        />
        <div>
          <img src={removeIcon} alt="" title="Delete" onClick={removeEnumeration} />
        </div>
      </StringEnumerationFieldStyled>
      {!!error && <FieldErrorStyled>{error}</FieldErrorStyled>}
    </>
  );
};
